import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const reportingIssuedRefundsAPI = async (params?: {
  startDate?: string;
  endDate?: string;
  format?: string;
}) => {
  const response = await baseAPI.get<string>('/reporting/issued-refunds', {
    params,
    responseType: 'text',
  });
  return response.data;
};

export const useReportingIssuedRefunds = (params?: {
  startDate?: string;
  endDate?: string;
  format?: string;
}) => {
  return useQuery({
    queryKey: [KEYS.ISSUED_REFUND, params],
    queryFn: () => reportingIssuedRefundsAPI(params),
    enabled: !!params?.format,
  });
};
